import { DeleteModal, ModalContext } from 'dash-ui';

import {
  GetAmenitiesDocument,
  GetAmenitiesForManageDocument,
  useDeleteAmenityMutation,
} from 'gql/generated.graphql';
import { useContext } from 'react';

const DeleteAmenityModal = () => {
  const [deleteAmenity, { loading }] = useDeleteAmenityMutation();
  const { payload } = useContext(ModalContext);

  const onSubmit = async () => {
    await deleteAmenity({
      variables: { amenityId: payload._id },
      refetchQueries: [GetAmenitiesDocument, GetAmenitiesForManageDocument],
    })
  }

  return (
    <DeleteModal
      entity="Amenity"
      name={payload?.name}
      isLoading={loading}
      onClick={onSubmit}
      modalName="DeleteAmenityModal"
      colorVariation="danger"
    />
  );
};

export default DeleteAmenityModal;
